<nz-result
nzStatus="success"
nzTitle="تمت عملية الحجز بنجاح"
nzSubTitle=""
>
</nz-result>

<div class="border-t border-gray-200 px-4 py-5 sm:px-6" style="display: grid;place-items: center;">
    <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2"  style="width: 100%;max-width: 500px">
      <div class="sm:col-span-1" style="margin: auto;">
        <dt class="text-lg font-medium text-gray-500" >أسم العميل</dt>
        <dd class="mt-1 text-xl text-gray-900">{{customerData['customer']['name']}} </dd>
      </div>
  
   
 
      <div class="sm:col-span-1" style="margin: auto;">
        <dt class="text-lg font-medium text-gray-500">رقم الهاتف </dt>
        <dd class="mt-1 text-xl text-gray-900">{{customerData['customer']['phone']}}  </dd>
      </div>
  


   
    
    </dl>


    <nz-table #basicTable [nzData]="customerData['appointments']" style="width: 100%;max-width: 500px;" [nzFrontPagination]="false" >
      <thead>
        <tr>
          <th> تاريخ الحجز</th>
          <th>وقت الحجز</th>
          <th>الملعب</th>
  
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of customerData['appointments'] ; let i = index">
          <td>   {{item['date'] | date}}</td>
          <td>{{ tConvert(item['time'])}}</td>
          <td>  
            
      <span *ngIf="item['court_id'] == 1"> الملعب الأول</span>
      <span *ngIf="item['court_id'] == 2">الملعب الثاني</span>
          </td>
      
        </tr>
      </tbody>
    </nz-table>
  </div>



  <a href="https://padelyard-om.com/customer/booking" style="display: grid;place-items: center;color: #52c41a;font-size: 16px;font-weight: bold;text-decoration: underline;">
    الرجوع لصفحة الحجز
  </a>
